import { SxProps, Theme } from "@mui/material";

export const modalContainer: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  padding: "62px 60px 95px 60px",
  maxHeight: "50vh",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

export const titleStyle: SxProps<Theme> = {
  fontSize: "32px",
  mb: 3,
};

export const fieldLabelStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 500,
  marginBottom: "8px",
  color: "#2D3748",
};

export const textFieldStyle: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    "& fieldset": {
      borderColor: "#CBD5E0",
    },
    "&:hover fieldset": {
      borderColor: "#A0AEC0",
    },
  },
};

export const buttonConfirmStyle: SxProps<Theme> = {
  backgroundColor: "black",
  borderRadius: "8px",
  ":hover": {
    backgroundColor: "#333",
  },
};

export const stackSpacingStyle: SxProps<Theme> = {
  mt: 4,
};

export const buttonCancelStyle: SxProps<Theme> = {
  variant: "outlined",
  color: "inherit",
  borderRadius: "8px",
  border: "1px solid black",
};
